var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('display-field',{attrs:{"field":_vm.field,"label-class":_vm.labelClass}},[_c('span',{class:_vm.valueClass},[_vm._v(" "+_vm._s(_vm._f("valueOrEmpty")(_vm._f("capitalize")(_vm._f("choice")(_vm.value,_vm.field))))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }